import { isNil, tryGetValue } from '../../utils';
import { SerializableObject } from './serializable-object';


export class MobizLogJob extends SerializableObject {
  public id: number;
  public parentId: number;
  public createdUtc: Date;
  public createdBy: string;
  public doneUtc: Date;
  public name: string;
  public trigger: string;
  public organizationId: string;
  public organizationName: string;
  public userId: string;
  public username: string;
  public done: boolean;
  public archived: boolean;
  public dontCleanup: boolean;
  public hasWarnings: boolean;
  public hasErrors: boolean;
  public hasDetails: boolean;

  public buildFromJSON(json: Object) {
    super.buildFromJSON(json);

    let createdUtcValue = tryGetValue<string>(json, 'createdUtc');
    if (!isNil(createdUtcValue) && typeof createdUtcValue === 'string') {
      this.createdUtc = new Date(createdUtcValue);
    }

    let doneUtcValue = tryGetValue<string>(json, 'doneUtc');
    if (!isNil(doneUtcValue) && typeof doneUtcValue === 'string') {
      this.doneUtc = new Date(doneUtcValue);
    }
  }
}
